import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskCandidatePulseSurveyRequested_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from 'src/entities/ActivityLog/Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskCandidatePulseSurveyRequested_ActivityLogFragment;
}

const ActivityLogTaskCandidatePulseSurveyRequested: FCWithFragments<Fragments> = ({ activityLog }) => {
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.notifiedCandidatePulseSurveyRequested"
    />
  );
};

ActivityLogTaskCandidatePulseSurveyRequested.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskCandidatePulseSurveyRequested_activityLog on ActivityLog {
      id
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskCandidatePulseSurveyRequested;
